/* eslint-disable react/jsx-no-duplicate-props */
import {
	Avatar,
	Box,
	Divider,
	VStack,
	HStack,
	IconButton,
	Icon,
	Text,
	Flex,
	Button,
	useDisclosure,
} from '@chakra-ui/react'
import React, { useRef, useEffect, useState } from 'react'
import { FaRegCheckCircle, FaRegCircle } from 'react-icons/fa'
import { BiMailSend } from 'react-icons/bi'
import { useLanguageContext } from '../../../context/locale.context'
import { sectionDetailedTrack } from '../../../containers/repository/repo.utils'
import { GA_CATEGORY_FILES } from './../../../containers/repository/repo.utils'
import OriginFormSendEmail from '../../../components/origin-form-email-model'
import { greeting, getShortName } from '../../../utils/common.util'
import { useAuthContext } from '../../../context/auth.context'
import { getLeaveTimeDate, getDayname } from '../../../utils/date.utils'
import Requestgreeting from '../request-greeting'
import ButtonCTA from '../../globalComponents/button'

const FormCategorySelector = ({
	onSelect,
	selected,
	list,
	onSelectTag,
	tagsList,
	formList,
	selectedTag,
	selectedTagType,
	onFormSelect,
	panelV,
	onClose,
}) => {
	const bottomRef = useRef()
	const {
		state: { locale },
	} = useLanguageContext()

	const [selFormData, setSelFormData] = useState({})
	const [firstView, setFirstView] = useState(true)
	const [scndView, setscndView] = useState(true)
	const [thirdView, setThirdView] = useState(true)

	const scrollToBottom = () => {
		bottomRef.current.scrollIntoView({
			behavior: 'smooth',
			block: 'start',
		})
	}

	useEffect(() => {
		scrollToBottom()
	}, [list, tagsList, formList])

	const {
		isOpen: isSendEmail,
		onOpen: onOpenSendEmail,
		onClose: onCloseSendEmail,
	} = useDisclosure()
	const fisrtReq = `${locale['Start a new request file by selecting a Request Type']}/${locale['Category from the list below']}`
	return (
		<>
			<Box py={3} px={5}>
				<Requestgreeting
					reqText={fisrtReq}
					greetingText={locale[greeting()]}
					height={'23vh'}
				/>
				{(list.tag_types || []).map(tagType => {
					const { form_tag_type_id } = tagType
					return (
						<Flex key={form_tag_type_id} justifyContent='flex-end'>
							<ButtonCTA
								variant='requestButton'
								onClick={() => {
									sectionDetailedTrack({
										category: GA_CATEGORY_FILES,
										action: 'Form Category Selector',
										label: 'Select Category',
									})
									onSelect(tagType)
								}}
								children={tagType.form_tag_type_name}
								mt='7px'
								isActive={
									tagType.form_tag_type_id === selectedTagType.form_tag_type_id
										? true
										: false
								}
								mr='15%'
							/>
						</Flex>
					)
				})}
				{(list.forms || []).map(form => {
					return (
						<Flex key={form.form_id} justifyContent='flex-end'>
							{/* TODO: onSelect function to b written to open form */}

							{form.activity_type_flag_enable_web_url === 1 ? (
								<>
									<Flex
										alignItems='center'
										mt='7px'
										mr='15%'
										bg='#FFFFFF'
										border='1px solid #009B76'
										color='brand.700'
										borderRadius='18px'
										h='28px'
										fontSize='13px'
										fontWeight='500'
										padding='8px 20px 8px 20px'
										fontStyle='normal'
									>
										<Text
											cursor='pointer'
											onClick={() => {
												sectionDetailedTrack({
													category: GA_CATEGORY_FILES,
													action: 'Form Category Selector',
													label: 'Form Select',
												})
												onFormSelect(form)
											}}
										>
											{form.form_workflow_activity_type_name}
										</Text>
										<Icon
											cursor='pointer'
											as={BiMailSend}
											color='brand.700'
											boxShadow='md'
											ml={2}
											w={4}
											h={4}
											onClick={() => {
												setSelFormData(form)
												onOpenSendEmail()
											}}
										/>
									</Flex>
								</>
							) : (
								<ButtonCTA
									variant='requestButton'
									onClick={() => {
										sectionDetailedTrack({
											category: GA_CATEGORY_FILES,
											action: 'Form Category Selector',
											label: 'Form Select',
										})
										onFormSelect(form)
									}}
									children={form.form_workflow_activity_type_name}
									mt='7px'
									isActive={selected ? true : false}
									mr='15%'
								/>
							)}
						</Flex>
					)
				})}
			</Box>

			{Object.keys(tagsList).length > 0 ? (
				<>
					<Box py={3} px={5}>
						<Requestgreeting
							reqText={`${locale['You Selected']} ${selectedTagType.form_tag_type_name} ${locale['Request Type']}, ${locale['now please select sub category of Request']}.`}
							greetingText={''}
							height={'20vh'}
						/>
						{(tagsList.tags || []).map(tag => {
							const { form_tag_id } = tag
							return (
								<Flex key={form_tag_id} justifyContent='flex-end'>
									<ButtonCTA
										variant='requestButton'
										isActive={
											form_tag_id === selectedTag.form_tag_id ? true : false
										}
										onClick={() => {
											sectionDetailedTrack({
												category: GA_CATEGORY_FILES,
												action: 'Form Category Selector',
												label: 'Select Tag',
											})
											onSelectTag(tag)
										}}
										children={tag.form_tag_name}
										mt='7px'
										mr='15%'
									/>
								</Flex>
							)
						})}
					</Box>
				</>
			) : null}

			{Object.keys(formList).length > 0 ? (
				<>
					<Box py={3} px={5}>
						<Requestgreeting
							reqText={`${locale['You Selected']} ${selectedTag.form_tag_name} ${locale['Request Type']}, ${locale['now please select sub category of Request']}.`}
							greetingText={''}
							height={'20vh'}
							isActive={selected ? true : false}
						/>

						{(formList.forms || []).map(form => {
							return (
								<Flex key={form.form_id} justifyContent='flex-end'>
									{form.activity_type_flag_enable_web_url === 1 ? (
										<>
											<Button
												mt='7px'
												mr='15%'
												bg='#FFFFFF'
												border='1px solid #009B76'
												color='brand.700'
												borderRadius='18px'
												h='28px'
												_active={{
													bgColor: '#009B76',
													color: '#FFFFFF',
													border: 'none',
												}}
												fontSize='13px'
												fontWeight='500'
												padding='8px 20px 8px 20px'
												fontStyle='normal'
											>
												<Text
													onClick={() => {
														sectionDetailedTrack({
															category: GA_CATEGORY_FILES,
															action: 'Form Category Selector',
															label: 'Form Select',
														})
														onFormSelect(form)
													}}
												>
													{form.form_workflow_activity_type_name}
												</Text>
												<IconButton
													ml='2'
													bg='#FFFFFF'
													borderRadius='md'
													boxShadow='md'
													size='30px'
													icon={<Icon as={BiMailSend} w={5} h={5} />}
													onClick={() => {
														setSelFormData(form)
														onOpenSendEmail()
													}}
												/>
											</Button>
										</>
									) : (
										<ButtonCTA
											variant='requestButton'
											isActive={selected ? true : false}
											onClick={() => {
												sectionDetailedTrack({
													category: GA_CATEGORY_FILES,
													action: 'Form Category Selector',
													label: 'Form Select',
												})
												onFormSelect(form)
											}}
											children={form.form_workflow_activity_type_name}
											mt='7px'
											mr='15%'
										/>
									)}
								</Flex>
							)
						})}
					</Box>
				</>
			) : null}
			<div ref={bottomRef}></div>
			{Object.keys(selFormData).length && !!isSendEmail ? (
				<OriginFormSendEmail
					isOpen={isSendEmail}
					onClose={onCloseSendEmail}
					activity={{}}
					form={selFormData}
				/>
			) : null}
		</>
	)
}

export default FormCategorySelector
